"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADORNMENT_POSITIONS = void 0;
var ADORNMENT_POSITIONS = Object.freeze({
  left: 'left',
  right: 'right'
});
exports.ADORNMENT_POSITIONS = ADORNMENT_POSITIONS;